import {
  images,
  scrolling,
} from 'assets/utilities';

import {
  faq,
  productGallery,
  productInfo,
  productIngredients,
  testimonials,
  productTechnology,
  productUgcImages,
  stickyAddToCart,
} from 'assets/components';

import './product.scss';

const STATE_CLASSNAME = 'state--product';

const destroy = function destroyProduct() {
  document.body.classList.remove(STATE_CLASSNAME);
  productInfo.destroy();
  productGallery.destroy();
  testimonials.destroy();
  productTechnology.destroy();
  productUgcImages.destroy();
  faq.destroy();
  productIngredients.destroy();
  stickyAddToCart.destroy();
};

const init = function initProduct(props = {}) {
  document.body.classList.add(STATE_CLASSNAME);
  window.scrollTo(0, 0);
  images.init();
  productInfo.init({ changeState: props.changeState });
  productGallery.init();
  scrolling.rebuildCache();
  testimonials.init();
  productTechnology.init();
  productUgcImages.init();
  faq.init();
  productIngredients.init();
  stickyAddToCart.init();
};

export default {
  destroy,
  init,
};
